export const useInitials = (value: string) => {
  const name: string = value?.trim() || "";

  if (!name) return "??";

  const parts: string[] = name.split(" ").filter(Boolean);

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[1][0]).toUpperCase();
};
